import { Box, Typography } from '@mui/material';
import { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as SuccessIcon } from 'src/assets/svg/success-green-circle.svg';

import { AuthContext } from '../../../providers/auth-context';

import { styles } from './styles';

export const LoggedInBanner: FC = () => {
    const { t } = useTranslation();

    const userState = useContext(AuthContext);
    if (!userState.loggedIn) {
        return null;
    }
    const { user_metadata: userMetadata } = userState.session.user;

    const userName = userMetadata.preferredName
        ? userMetadata.preferredName
        : userMetadata?.firstName;

    return (
        <Box css={styles.container}>
            <Box css={styles.infoWrapper}>
                <SuccessIcon />
                <Box css={styles.info}>
                    <Typography variant="h2">
                        {t('your_details_logged_in_title', {
                            name: userName,
                        })}
                    </Typography>
                    <Typography variant="body3">{t('your_details_logged_in_subtitle')}</Typography>
                </Box>
            </Box>
        </Box>
    );
};
